// extracted by mini-css-extract-plugin
export default {"title":"blog-module--title--349cc","item":"blog-module--item--f9ede","itemActive":"blog-module--item--active--a03d1"};